var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46824 6.55574L11.8083 1.6606C11.9319 1.54738 12 1.39625 12 1.23509C12 1.07394 11.9319 0.922802 11.8083 0.809583L11.4151 0.44909C11.1589 0.214515 10.7425 0.214515 10.4867 0.44909L6.00249 4.55966L1.51326 0.444529C1.38965 0.33131 1.22487 0.268798 1.04916 0.268798C0.873261 0.268798 0.708482 0.33131 0.584775 0.444529L0.191706 0.805022C0.0680971 0.91833 -3.49944e-08 1.06938 -4.20387e-08 1.23053C-4.90829e-08 1.39168 0.0680971 1.54282 0.191706 1.65604L5.53664 6.55574C5.66064 6.66923 5.8262 6.73156 6.00219 6.7312C6.17888 6.73156 6.34434 6.66923 6.46824 6.55574Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.b4d33d6df060e502a7e42062a2962eb1.svg";
export { ForwardRef as ReactComponent };